export const isCreateOrderProductVisible = (product, shippingArea) => {
  if (!product || !product.enabled) return false
  return String(product.shippingArea || '') === String(shippingArea || '')
}
